export default __webpack_public_path__ + "static/BgkDivas-ab8c006a3c8b897502ec9429d8bc353f.png";